import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

// Always-on, deterministic 'Why this exists' (spec 11.5): authored, bound context-record text (the
// why) shown beside the on-page facts (the what). No model, no key; the cure for surfaces that read
// like code. Renders nothing when there is no record (404) rather than a placeholder. Spine codes
// and jargon are humanized server-side, so this is plain rendering of clean bound strings.
export default function WhyThisExists({ engineId, interventionId }: { engineId: number; interventionId?: string }) {
  const q = useQuery({
    queryKey: ['context', engineId, interventionId ?? null],
    queryFn: () => api.context(engineId, interventionId),
    staleTime: 5 * 60_000,
    retry: false,
  });
  const rec = q.data;
  if (!rec) return null;
  const lines = interventionId
    ? [{ label: 'Why it exists', body: rec.root_cause }, { label: 'What it defends', body: rec.purpose_defended }]
    : [{ label: 'What it is for', body: rec.what_it_is_for }, { label: 'How its parts fit', body: rec.how_interventions_fit }];
  const shown = lines.filter((l) => l.body);
  if (shown.length === 0) return null;
  return (
    <div className="panel" style={{ marginBottom: 14, borderLeft: '3px solid var(--line-soft)' }}>
      <div className="small faint" style={{ textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: 11, marginBottom: 6 }}>
        Why this exists
      </div>
      {shown.map((l) => (
        <div key={l.label} className="small" style={{ marginBottom: 6, lineHeight: 1.5 }}>
          <b>{l.label}:</b> {l.body}
        </div>
      ))}
    </div>
  );
}
